export default __webpack_public_path__ + "static/media/building-torre-texao.5b0df9ff.png";